import * as React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import { message, Button, Modal, Tooltip } from 'antd';
import ActivityApiController from 'src/api/ActivityApiController';
import ActivitySummaryDTO from 'src/models/activity/ActivitySummaryDTO';


export interface ActivitySummariesProps extends LocalizeContextProps {
    activityId: number;
    shouldRefreshTable: boolean;
    updateShouldRefreshTable: () => void;
}

interface ActivitySummariesState {
    loading: boolean;
    tableRecords: ActivitySummaryDTO[];
    formRedirect: boolean;
}

class ActivitySummaries extends React.Component<ActivitySummariesProps, ActivitySummariesState> {
    private dataTableRef: DataTable<ActivitySummaryDTO>;

    constructor(props: ActivitySummariesProps) {
        super(props);
        bindAllOfThis(this, ActivitySummaries.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false,
        };
    }

    private deleteActivitySummary(activitySummaryId: number) {
        let ref = this.dataTableRef;
        let translate: (id: any) => any = this.props.translate;

        Modal.confirm({
            title: translate('admin.activitySummaries.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk() {
                ActivityApiController.deleteActivitySummary(activitySummaryId).then(result => {
                    message.success(translate('admin.activitySummaries.messageDelete'));
                    ref.refresh();
                }).catch(e => {
                    message.error(this.props.translate('admin.activitySummaries.messageDeleteError'));
                });
            },
        });
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ActivitySummaryDTO>) => void): void {
        this.setState({ loading: true });
        ActivityApiController.getActivitySummaryTableData(requestState, this.props.activityId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<ActivitySummaryDTO>[] {
        let editLink = (text, record: ActivitySummaryDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_SUMMARY, this.props.activityId, record.activitySummaryId);

        let columns: DataTableColumnProps<ActivitySummaryDTO>[] = [
            DataTable.StandardColumns.Text('admin.activitySummaries.columnHeader1', 'text'),
            DataTable.StandardColumns.NumberAllowZero('admin.activitySummaries.columnHeader2', 'scoreMin'),
            DataTable.StandardColumns.NumberAllowZero('admin.activitySummaries.columnHeader3', 'scoreMax'),
            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={this.props.translate('admin.common.deleteColumnHeader')} arrowPointAtCenter>
                                <Button shape="circle" icon="delete" onClick={() => this.deleteActivitySummary(record.activitySummaryId)} />
                            </Tooltip>
                        );
                    }
                }
            }
        ];

        return columns;
    }

    render() {
        if (this.state.formRedirect) {
            return <Redirect to={Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_SUMMARY, this.props.activityId, 0)} push />;
        } else if (this.props.shouldRefreshTable) {
            this.dataTableRef.refresh();
            this.props.updateShouldRefreshTable();
        }

        return (
            <div>
                <h2>{this.props.translate('admin.activitySummaries.tableHeader')}</h2>
                <DataTable
                    ref={ref => this.dataTableRef = ref}
                    serverSide={true}
                    tableProps={{ rowKey: 'activitySummaryId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('admin.activitySummaries.addButton', () => { this.setState({ formRedirect: true }); }),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

export default withLocalize(ActivitySummaries as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/ActivitySummaries.tsx